var _defs, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBgVideoueberwachungSlider = function SvgBgVideoueberwachungSlider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 320
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "BG-Videoueberwachung-slider_svg__b",
    cx: 0.5,
    cy: 0.5,
    r: 1.059,
    gradientTransform: "matrix(.531 0 0 .652 .235 .174)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0eaec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BG-Videoueberwachung-slider_svg__a",
    x1: 0.5,
    x2: 0.5,
    y1: -0.048,
    y2: 1.018,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0eaec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#f7fafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0eaec"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 320,
    fill: "url(#BG-Videoueberwachung-slider_svg__a)",
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 320,
    fill: "url(#BG-Videoueberwachung-slider_svg__b)",
    rx: 3
  })));
};
export default SvgBgVideoueberwachungSlider;